import {
	ClientWorkingTimeState,
	StoreAction,
} from '../../interfaces/redux.interface';
import * as ClientWorkingTimeActions from '../constants/clientWorkingTime';

const initialState: ClientWorkingTimeState = {
	data: {},
	compareData: {},
	selectedTab: 2,
};

const clientWorkingTimeReducer = (
	state: typeof initialState = initialState,
	action: StoreAction<any>,
): ClientWorkingTimeState => {
	switch (action.type) {
		case ClientWorkingTimeActions.GET_CLIENT_WORKING_TIME_SUCCESS:
			return {
				...state,
				data: action.payload,
			};
		case ClientWorkingTimeActions.GET_CLIENT_COMPARE_COMPANIES_SUCCESS:
			return {
				...state,
				compareData: action.payload.data,
				selectedTab: action.payload.selectedTab,
			};
		default:
			return state;
	}
};

export default clientWorkingTimeReducer;
